const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function showAreaWheelText(target, count) {
    target.setAttribute('data-current-count', count);
    const targetWrapper = target.closest(".areaWheelWrapper");
    if (!targetWrapper) return;
    for (const description of targetWrapper.querySelectorAll('.areaWheel__textItem')) {
        if (description.hasAttribute('data-count')) {
            if (parseInt(description.dataset.count) === parseInt(count)) {
                description.classList.add('is-active');
            } else {
                description.classList.remove('is-active');
            }
        } else {
            description.classList.remove('is-active');
        }
    }
}

function getAngleForDescription(target, description) {
    const circleRect = target.getBoundingClientRect();
    const centerX = circleRect.left + circleRect.width / 2;
    const centerY = circleRect.top + circleRect.height / 2;

    const point = description.querySelector('.areaWheel__descriptionPoint');
    const pointRect = point.getBoundingClientRect();
    const dx = (pointRect.left + pointRect.width / 2) - centerX;
    const dy = (pointRect.top + pointRect.height / 2) - centerY;

    // Angle from 12 o'clock, clockwise
    let angle = Math.atan2(dx, -dy) * (180 / Math.PI);
    if (angle < 0) angle += 360;
    return angle;
}

export function checkAreaWheelAnimation(target) {
    if (!target) return;
    if (prefersReducedMotion) return;

    const areaDescriptions = target.querySelectorAll('.areaWheel__description');
    const activePointWrapper = target.querySelector('.activePointWrapper');
    let currentIndex = 0;
    let totalRotation = 0;

    // Disable CSS animation, use JS-driven transform instead
    activePointWrapper.style.animation = 'none';
    activePointWrapper.style.transition = 'transform 0.6s ease-in-out';

    function goToNext() {
        const description = areaDescriptions[currentIndex];
        const targetAngle = getAngleForDescription(target, description);

        // Always move clockwise
        const currentMod = ((totalRotation % 360) + 360) % 360;
        let diff = targetAngle - currentMod;
        if (diff < 0) diff += 360;
        totalRotation += diff;

        activePointWrapper.style.transform = `rotate(${totalRotation}deg)`;

        for (const desc of areaDescriptions) {
            desc.classList.remove('is-active');
        }
        description.classList.add('is-active');
        target.classList.add('is-active');
        showAreaWheelText(target, description.dataset.count);

        currentIndex = (currentIndex + 1) % areaDescriptions.length;
    }

    target.classList.add('is-running');
    goToNext();
    setInterval(goToNext, 1500);
}

export function initAreaWheel() {
    for (const areaWheel of document.querySelectorAll('.areaWheel')) {
        const count = areaWheel.querySelectorAll('.areaWheel__description').length;
        if (count > 6) {
            areaWheel.classList.add('areaWheel--8');
        }
        checkAreaWheelAnimation(areaWheel);
    }
}